const StatusIndicatorInactiveLight = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='8' height='45' viewBox='0 0 8 45'>
      <defs>
        <clipPath id='clip-slate'>
          <rect width='8' height='45' rx='2' />
        </clipPath>
        <filter id='shadow-slate' x='-50%' y='-50%' width='200%' height='200%'>
          <feDropShadow dx='0' dy='0' stdDeviation='3' floodColor='#64748b' floodOpacity='0.6' />
        </filter>
      </defs>

      <g clipPath='url(#clip-slate)'>
        <rect width='8' height='45' rx='2' fill='#64748b' filter='url(#shadow-slate)' />
        <rect
          x='0.5'
          y='0.5'
          width='7'
          height='44'
          rx='1.5'
          fill='none'
          stroke='#475569'
          strokeWidth='1'
          vectorEffect='non-scaling-stroke'
        />
      </g>
    </svg>
  )
}

export { StatusIndicatorInactiveLight }
